import { makeStyles } from '@material-ui/core/styles'
import { createStyles, Theme } from '@material-ui/core'

export const useHomeStyles = makeStyles((theme: Theme) =>
  createStyles({
    filterContainer: {
      position: 'relative',
      zIndex: 999,
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        marginTop: 0,
      },
    },
    mobileControls: {
      display: 'grid',
      gridTemplateColumns: '40px 72px',
      alignItems: 'end',
      justifyContent: 'space-between',
      gap: theme.spacing(1),
      width: '100%',
      marginBottom: theme.spacing(1),
    },
    mobileFilterControl: {
      width: 40,
    },
    mobileShowItemsSelect: {
      width: 72,
      minWidth: '0 !important',
      '& label': {
        display: 'none',
      },
      '& .MuiOutlinedInput-root': {
        minHeight: 40,
      },
      '& .MuiSelect-select': {
        minHeight: 40,
        padding: theme.spacing(0, 1),
        paddingRight: theme.spacing(3),
      },
    },
  })
)
